<form class="form-group odd" id="name_field_box">
  <label class="col-sm-3 control-label" for="name" id="name_display_as_box">
    <font style="vertical-align: inherit">
      <font style="vertical-align: inherit">
        {{ settingsI18n?.nameI18n }}
      </font> </font
    ><span class="required">
      <font style="vertical-align: inherit">
        <font style="vertical-align: inherit">*</font>
      </font>
    </span>
  </label>
  <div class="col-sm-9 col-md-6 col-lg-6" id="name_input_box">
    <input
      [(ngModel)]="model.name"
      id="field-name"
      value="{{ model.name }}"
      name="name"
      class="form-control"
      type="text"
      maxlength="99"
    />
    <br />
  </div>

  <label class="col-sm-3 control-label" for="name" id="name_display_as_box">
    <font style="vertical-align: inherit">
      <font style="vertical-align: inherit">
        {{ settingsI18n?.telephoneI18n }}
      </font> </font
    ><span class="required">
      <font style="vertical-align: inherit">
        <font style="vertical-align: inherit">*</font>
      </font>
    </span>
  </label>
  <div class="col-sm-9 col-md-6 col-lg-6" id="name_input_box">
    <input
      [(ngModel)]="model.telephone"
      id="field-name"
      value="{{ model.telephone }}"
      name="telephone"
      class="form-control"
      type="text"
      maxlength="99"
    />
    <br />
  </div>

  <label class="col-sm-3 control-label" for="name" id="name_display_as_box">
    <font style="vertical-align: inherit">
      <font style="vertical-align: inherit">
        {{ settingsI18n?.addressI18n }}
      </font> </font
    ><span class="required">
      <font style="vertical-align: inherit">
        <font style="vertical-align: inherit">*</font>
      </font>
    </span>
  </label>
  <div class="col-sm-9 col-md-6 col-lg-6" id="name_input_box">
    <input
      [(ngModel)]="model.address"
      id="field-name"
      value="{{ model.address }}"
      name="address"
      class="form-control"
      type="text"
      maxlength="99"
    />
    <br />
  </div>

  <label class="col-sm-3 control-label" for="name" id="name_display_as_box">
    <font style="vertical-align: inherit">
      <font style="vertical-align: inherit">
        {{ settingsI18n?.faxI18n }}
      </font> </font
    ><span class="required">
      <font style="vertical-align: inherit">
        <font style="vertical-align: inherit">*</font>
      </font>
    </span>
  </label>
  <div class="col-sm-9 col-md-6 col-lg-6" id="name_input_box">
    <input
      [(ngModel)]="model.fax"
      id="field-name"
      value="{{ model.fax }}"
      name="fax"
      class="form-control"
      type="text"
      maxlength="99"
    />
    <br />
  </div>

  <label class="col-sm-3 control-label" for="name" id="name_display_as_box">
    <font style="vertical-align: inherit">
      <font style="vertical-align: inherit">
        {{ settingsI18n?.languageI18n }}
      </font> </font
    ><span class="required">
      <font style="vertical-align: inherit">
        <font style="vertical-align: inherit">*</font>
      </font>
    </span>
  </label>
  <div class="col-sm-9 col-md-6 col-lg-6" id="name_input_box">
    <select
      [(ngModel)]="model.lang"
      id="field-name"
      name="lang"
      class="form-control"
      maxlength="99"
    >
      <option value="EN">
        <span class="flag-icon flag-icon-us"></span>ENGLISH
      </option>
      <option value="AR">
        <span class="flag-icon flag-icon-ae"></span>عربى
      </option>
      <option value="HN">
        <span class="flag-icon flag-icon-in"></span>हिन्दी
      </option>
      <option value="BN">
        <span class="flag-icon flag-icon-bd"></span>বাংলা
      </option>
    </select>
    <br />
  </div>
  <button (click)="edit()" type="button" class="btn btn-info">
    <i class="fas fa-save"></i>
    {{ settingsI18n?.editButtonI18n }}
  </button>
</form>
